/**
 * BLOCK: FAQ - Child
 */
import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import lazyLoader from '@Controls/lazy-loader';

const Settings = lazy(() =>
	import(/* webpackChunkName: "chunks/faq-child/settings" */ './settings')
);
const Render = lazy(() =>
	import(/* webpackChunkName: "chunks/faq-child/render" */ './render')
);

const initialState = {
	isFocused: false,
};

const WPSPFaqChildEdit = (props) => {
	const [state, setStateValue] = useState(initialState);
	const prevStateRef = useRef(null);

	useEffect(() => {
		// Replacement for componentDidMount.

		// Assigning block_id in the attribute.
		props.setAttributes({ block_id: props.clientId.substr(0, 8) });
		// Pushing Style tag for this block css.
		prevStateRef.current = props.isSelected;
	}, []);

	useEffect(() => {
		// Replacement for componentDidUpdate.

		if (!props.isSelected && prevStateRef.current && state.isFocused) {
			setStateValue({
				isFocused: false,
			});
		}
		if (props.isSelected && !prevStateRef.current) {
			setStateValue({
				isFocused: true,
			});
		}
		prevStateRef.current = props.isSelected;
	}, [props.isSelected]);

	return (
		<>
			<Suspense fallback={lazyLoader()}>
				<Render state={state} parentProps={props} />
				<Settings />
			</Suspense>
		</>
	);
};

export default WPSPFaqChildEdit;
